import {Component, Injector, Input, ViewChild} from '@angular/core';
import {BaseComponent} from '../base/base.component';
import {TableComponent} from '../ui/table/table.component';
import {DomainRecord} from '../../models/domain';
import {DomainService} from '../../services/domain/domain.service';

@Component({
    selector: 'app-admin-domains',
    templateUrl: './admin-domains.component.html',
    styleUrls: ['./admin-domains.component.scss']
})
export class AdminDomainsComponent extends BaseComponent {
    @Input() embedded = false;
    @ViewChild('domainsTable') domainsTable!: TableComponent;
    searchText = '';
    copiedKey = '';
    skeletonRows = [1, 2, 3, 4, 5];
    private copiedTimer: ReturnType<typeof setTimeout> | null = null;

    constructor(
        serviceInjector: Injector,
        private domainService: DomainService,
    ) {
        super(serviceInjector);
    }

    ngAfterViewInit(): void {
        if (!this.isSuperAdmin()) {
            this.goTo('/admins/dashboard');
            return;
        }
        setTimeout(() => this.reloadTable());
    }

    reloadTable() {
        this.domainsTable?.loadData(
            '/admin/domains',
            {},
            (item: any) => new DomainRecord(item),
            true
        );
    }

    fieldLabel(field?: string) {
        return field === 'shopDomain' ? 'Shop' : 'Società';
    }

    searchRecords() {
        this.domainsTable.searchText = this.searchText;
        this.domainsTable.searchElement();
    }

    resetSearch() {
        this.searchText = '';
        this.domainsTable.resetSearch();
    }

    copyValue(value: string | undefined, key: string) {
        if (!value) return;
        navigator.clipboard.writeText(value).then(() => {
            this.copiedKey = key;
            if (this.copiedTimer) clearTimeout(this.copiedTimer);
            this.copiedTimer = setTimeout(() => {
                this.copiedKey = '';
                this.copiedTimer = null;
            }, 1400);
        }).catch(() => {
            this.showErrorMessage('Impossibile copiare');
        });
    }

    async deleteRecord(domain: DomainRecord) {
        const confirmed = await this.showQuestionMessage();
        if (!confirmed) return;

        this.showSpinner();
        const response = await this.domainService.removeDomain({
            companyId: domain.companyId,
            recordId: domain.recordId,
            field: domain.field
        });
        this.hideSpinner();

        if (!response.success) {
            this.showErrorMessage(this.domainService.domainErrorMessage(response, 'Impossibile eliminare il record DNS'));
            return;
        }

        this.showSuccessMessage('Record DNS eliminato');
        this.reloadTable();
    }
}
